import { render, staticRenderFns } from "./HomePage.nl.vue?vue&type=template&id=973f7618&"
import script from "./HomePage.nl.vue?vue&type=script&lang=ts&"
export * from "./HomePage.nl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports